// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".period-wrapper[data-v-3d3ffc04] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.period-wrapper[data-v-3d3ffc04] .c-input-required {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
